import React from 'react';

const LanguageList = () => {
  return (
    <>
      <button className="btn btn-secondary dropdown-toggle" type="button" id="languageSelectDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        English
      </button>
      <ul className="dropdown-menu" aria-labelledby="languageSelectDropdown">
        <li>
          <button className="dropdown-item" type="button">
            Other languages
          </button>
        </li>
      </ul>
    </>
  );
};

export default LanguageList;
